// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__337mY","checkboxCol":"Table_checkboxCol__1c17m","emailCol":"Table_emailCol__3jpjC","actionCol":"Table_actionCol__30raj"};